exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "a.menu-selector-item {\n    color: white;\n    font-size: 16px;\n}\n\nng-sidebar .ng-sidebar--left {\n    width: 250px;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding-left: 15px;\n    overflow: hidden;\n    font-style: initial;\n    background-color: #003169;\n}\n\n/*\ndiv.menu-module-item {\n    cursor: hand;\n    width: 99.3%;\n    height: 35px;\n    font-size: 12;\n    font-style: initial;\n    background: rgb(239, 239, 239);\n    border: 1px solid #d5d3cd;\n    box-shadow: inset 0 0px 0px 0px rgba(243, 243, 243, 0.08);\n    color: #4c4c4c;\n} */", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./app/core/components/menu-selector-module/menu-selector-module.component.css
// module id = 1135
// module chunks = 7